<template>
  <!--begin::Invoice Listing-->
  <div class="leave-template">
    <PageHeaderCount
      moduleType="leave"
      :dataLoading="dataLoading"
      :statusList="statusList"
      allkey="all_leaves"
      countkey="leave_status_count"
    />
    <ListingTemplate
      :customClass="'leave-listing'"
      v-if="getPermission('leave:view')"
    >
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-flex class="pt-0 mxw-200 my-auto">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  {{ totalSelected }} Selected
                </h1>
              </v-flex>
              <v-flex class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('leave:update')">
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    transition="slide-y-transition"
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="dataLoading"
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(more, index) in bulkActions">
                        <v-list-item
                          link
                          v-on:click="updateBulkAction(more.action)"
                          :key="index"
                          v-if="more.isActive"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              more.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ more.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-flex>
            </template>
            <template v-else>
              <v-flex class="pt-0 mxw-200">
                <h1 class="form-title d-flex margin-auto">
                  <v-select
                    :disabled="dataLoading"
                    :items="statusList"
                    v-model="status"
                    @change="getRows"
                    hide-details
                    item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter"
                    item-text="text"
                    item-value="value"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          :color="item.color"
                          :text-color="item.textcolor"
                        >
                          <template v-if="item.value == 'all'">
                            {{ item.all_leaves }}</template
                          >
                          <template v-else>{{
                            item.leave_status_count
                          }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-flex>
              <v-flex class="pt-0 pr-0 justify-flex-end d-flex">
                <template v-if="getPermission('leave:create')">
                  <v-btn
                    depressed
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button custom-btn-color white--text"
                    @click="create_leave_dialog = true"
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <!-- <v-btn
                  depressed
                  v-if="false && !isEngineerChannel()"
                  v-on:click="
                    $router.push(
                      getDefaultRoute('profile.setting', {
                        query: {
                          tab: 'leave',
                        },
                      })
                    )
                  "
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button pr-0"
                  color="cyan white--text"
                >
                  <v-icon dark>mdi-cog</v-icon>
                </v-btn> -->
                <v-menu
                  v-if="false"
                  content-class="custom-menu-list"
                  offset-y
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading || exportLoading"
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                      :loading="exportLoading"
                    >
                      <v-icon dark>mdi-menu</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <template v-for="(item, index) in moreActions">
                      <v-list-item
                        :key="index"
                        link
                        :class="{ 'line-active': item.sort }"
                        v-on:click="moreAction(item.action, item.sort)"
                      >
                        <v-list-item-title>
                          <v-icon v-if="item.icon" small left color="cyan">{{
                            item.icon
                          }}</v-icon>
                          {{ item.title }}
                          <template v-if="item.sort">
                            <v-icon
                              v-if="item.sort == 'asc'"
                              small
                              right
                              color="cyan"
                              >mdi-sort-ascending</v-icon
                            >
                            <v-icon
                              v-if="item.sort == 'desc'"
                              small
                              right
                              color="cyan"
                              >mdi-sort-descending</v-icon
                            >
                          </template>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
                <v-menu
                  max-height="400"
                  max-width="250"
                  offset-y
                  left
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    v-on:change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          v-on:change="updateVisible()"
                          color="cyan"
                          hide-details
                          class="pt-2 mt-0"
                        ></v-checkbox>
                        <v-icon
                          class="draggable-drag-icon"
                          small
                          right
                          color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>

                <entity-dropdown
                  v-if="is_main_super_admin > 0"
                  :entity="entity"
                  :entityList="entityList"
                  :loading="dataLoading"
                  @change="updateEntity"
                />
                <PageTips v-if="false" module="leave"></PageTips>
              </v-flex>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="leave"
          :basicSearchFields="[
            'barcode',
            'reason',
            'category',
            'staff[display_name]',
          ]"
          :allowedSearchFields="searchableArray"
        ></ListingSearchCriteria>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.id"
                      class="simple-table-th"
                      :class="{
                        'checkbox-width-limit': cols.checkbox,
                        'pointer-events-none': lodash.isEmpty(rowData),
                      }"
                      :style="{ 'max-width': cols.width }"
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          v-on:click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : 'javascript:void(0)'
                          "
                        >
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'asc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-ascending</v-icon
                          >
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'desc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-descending</v-icon
                          >
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="rowData.length > 0">
                  <tr
                    v-for="(data, index) in rowData"
                    :key="index"
                    link
                    class="customer-listing-row leave-listing-row"
                  >
                    <template v-for="cols in customThead">
                      <td
                        v-if="cols.visible"
                        :key="cols.id"
                        :class="{
                          'simple-table-td': !cols.checkbox,
                          'checkbox-width-limit': cols.checkbox,
                        }"
                        :style="{ 'max-width': cols.width }"
                        v-on:click="
                          Number(cols.checkbox) == 0
                            ? rowClicked(data)
                            : 'javascript:void(0)'
                        "
                      >
                        <template
                          v-if="cols.checkbox && Number(cols.checkbox) == 1"
                        >
                          <v-checkbox
                            dense
                            :disabled="data.status == 5"
                            v-model="selectedRows"
                            v-bind:value="data.id"
                            color="cyan"
                            class="hide-margin"
                            hide-details
                          ></v-checkbox>
                        </template>
                        <template v-else-if="cols.field == 'barcode'">
                          <div>
                            <Barcode :barcode="data[cols.field]"></Barcode>
                          </div>
                        </template>

                        <!-- <template v-else-if="cols.field == 'staff'">
                          <div class="leave-listing-customer">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <template v-if="data?.staff.display_name">
                                {{ data?.staff.display_name }}
                              </template>
                              <template v-else
                                ><em class="text--secondary"
                                  >No Display Name</em
                                ></template
                              >
                            </p>
                          </div>
                        </template> -->
                        <template v-else-if="cols.field == 'staff'">
                          <div
                            class="leave-listing-customer font-weight-700 text-capitalize"
                            v-if="data?.staff.display_name"
                          >
                            <p class="m-0 custom-nowrap-ellipsis">
                              {{ data?.staff.display_name }}
                            </p>
                          </div>
                          <em class="text-muted" v-else> no staff </em>
                        </template>
                        <template v-else-if="cols.field == 'entity'">
                          <div
                            class="leave-listing-customer font-weight-700"
                            v-if="data?.entity.name"
                          >
                            <p class="m-0 custom-nowrap-ellipsis">
                              {{ data?.entity.name }}
                            </p>
                          </div>
                          <em class="text-muted" v-else> no entity </em>
                        </template>
                        <!-- <template v-else-if="cols.field == 'category'">
                          <div class="job-listing-customer">
                            <p class="m-0" v-if="data && data?.category">
                              <v-chip
                                class="mx-2 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                                color="blue darken-1"
                                label
                                small
                                text-color="white"
                              >
                                {{ data?.category.replace("-", " ") }}
                              </v-chip>
                            </p>
                            <em v-else class="text-muted"> no category</em>
                          </div>
                        </template> -->
                        <template v-else-if="cols.field == 'start_date'">
                          <div
                            class="job-listing-customer"
                            v-if="data && data?.start_date"
                          >
                            <v-chip
                              label
                              color="green"
                              text-color=""
                              outlined
                              small
                            >
                              {{ formatDate(data?.start_date) }}
                            </v-chip>
                          </div>
                          <em v-else class="text-muted"> no start date</em>
                        </template>
                        <template v-else-if="cols.field == 'end_date'">
                          <div
                            class="job-listing-customer"
                            v-if="data && data?.end_date"
                          >
                            <v-chip
                              label
                              color="red"
                              text-color=""
                              outlined
                              small
                            >
                              {{ formatDate(data?.end_date) }}
                            </v-chip>
                          </div>
                          <em v-else class="text-muted"> no end date</em>
                        </template>
                        <!-- <template v-else-if="cols.field == 'status'">
                          <v-chip
                            label
                            small
                            :color="data?.status_color"
                            :text-color="data?.status_textcolor"
                            class="ml-2 text-uppercase font-weight-600"
                          >
                            {{ data?.status_text }}
                          </v-chip>
                          <CustomStatus
                            v-if="false"
                            small
                            :status="data.status"
                            endpoint="leave/status"
                          ></CustomStatus>
                        </template> -->

                        <template v-else-if="cols.field == 'status'">
                          <v-menu
                            :disabled="isDisabled(data)"
                            offset-y
                            min-width="100px"
                            style="padding: 0px 4px"
                            rounded
                            bottom
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on">
                                <v-chip
                                  small
                                  class="ml-2 text-uppercase font-weight-600"
                                  :color="`${
                                    data.status_text == 'Pending'
                                      ? 'orange'
                                      : data.status_text == 'Approved'
                                      ? 'green'
                                      : data.status_text == 'Rejected'
                                      ? 'red'
                                      : data.status_text == 'Cancelled'
                                      ? 'teal'
                                      : 'grey'
                                  } white--text`"
                                  outlined
                                  dence
                                  text-color=""
                                >
                                  <!-- <pre>{{ data.status_text }}</pre> -->
                                  {{ data.status_text }}
                                  <v-icon style="font-size: 22px" small right
                                    >mdi-menu-down</v-icon
                                  >
                                </v-chip>
                              </div>
                            </template>

                            <v-list>
                              <v-list-item
                                class="list-item cursor-pointer p-1"
                                v-for="(item, index) in statusDropdown"
                                :key="index"
                                @click="updateStatus(item.value, data)"
                              >
                                <v-list-item-title class="pl-4">
                                  {{ item.text }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>

                          <!-- Overdue Chip -->
                          <v-chip
                            v-if="getOverdue(data)"
                            small
                            class="ml-2 text-white"
                            color="red"
                            dark
                          >
                            Overdue
                          </v-chip>
                        </template>
                        <template v-else-if="cols.field == 'half_day'">
                          <template v-if="data && data?.duration">
                            <div
                              class="d-flex align-center flex-wrap leave-halfday-responsive"
                            >
                              <div class="halfday-block">
                                <b class="d-inline-block font-weight-700"
                                  >Second:</b
                                >
                                <span v-if="data?.second_half_start_date">
                                  {{ formatDate(data.start_date) }}
                                </span>
                                <em class="text-muted" v-else>not provided</em>
                              </div>

                              <div class="halfday-block">
                                <b class="d-inline-block font-weight-700"
                                  >First:</b
                                >
                                <span v-if="data?.first_half_of_end_date">
                                  {{ formatDate(data.end_date) }}
                                </span>
                                <em class="text-muted" v-else>not provided</em>
                              </div>
                            </div>
                          </template>

                          <template v-else>
                            <em class="text-muted">no half day</em>
                          </template>
                        </template>
                        <template v-else-if="cols.field == 'total_leave_days'">
                          <div
                            style="max-width: fit-content"
                            class="mt-1"
                            v-if="data?.total_leave_days > 0"
                          >
                            <span class="mb-2">
                              <v-avatar color="green" size="27">
                                <span class="white--text fw-600">
                                  {{ data?.total_leave_days }}</span
                                >
                              </v-avatar>
                            </span>
                          </div>
                          <em class="text-muted" v-else> no total leave day</em>
                        </template>

                        <template v-else-if="cols.field == 'added_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.added_by)"
                            :data="data"
                          >
                            <template v-slot:display_name>
                              {{ data.added_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              <template v-if="getDateCountAll(data.added_at)">{{
                                data.created_at
                              }}</template>
                              <template v-else>{{
                                formatDateTime(data.added_at)
                              }}</template>
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDateTime(data.added_at) }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else-if="cols.field == 'updated_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.updated_by)"
                            :data="data"
                          >
                            <template v-slot:display_name>
                              {{ data.updated_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              {{ data.modified_at }}
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDateTime(data.updated_at) }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else>
                          <div v-html="printRowData(cols, data)"></div>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <tr v-else-if="!dataLoading">
                  <td :colspan="15" class="py-4">
                    <p
                      class="m-0 row-not-found text-center font-weight-500 font-size-16"
                    >
                      <img
                        :src="$assetURL('media/error/empty.png')"
                        class="row-not-found-image"
                      />
                      Uhh... There are no leave at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
        <Dialog :commonDialog="searchDialog">
          <template v-slot:title>Filter leave</template>
          <template v-slot:body>
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <v-col md="6">
                    <v-menu
                      v-if="false"
                      v-model="datePicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          filled
                          flat
                          label="Dates Range"
                          hide-details
                          solo
                          clearable
                          v-on:click:clear="dates = []"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :value="formattedDate"
                          color="cyan"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="cyan"
                        range
                        v-model="dates"
                      ></v-date-picker>
                    </v-menu>
                    <DateRangePicker
                      placeholder="Data Range"
                      v-model="dates"
                      v-on:click:clear="clearFilter('dates')"
                      class="mr-2"
                    ></DateRangePicker>
                  </v-col>
                  <template v-for="(field, index) in searchableArray">
                    <v-col md="6" :key="index" v-if="field != 'dates'">
                      <v-text-field
                        v-model.trim="listingSearch[field]"
                        dense
                        filled
                        hide-details
                        :label="getFilterLabel(field, 'Leave')"
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
            <v-btn
              depressed
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>

        <Dialog
          v-if="statusDialog"
          :common-dialog="statusDialog"
          :dialog-width="640"
          isClass
        >
          <template v-slot:title>
            <div class="d-flex">Confirmed</div>
          </template>
          <template v-slot:body>
            <v-form v-model="formValid">
              <v-row class="delete-dialog">
                <v-col md="12" class="py-0 my-auto py-2">
                  <div class="btx-div m-0" v-if="statusdata == 'approved'">
                    <span class="font-weight-600">
                      <template v-if="visits && visits.visitBarcode">
                        <div style="font-size: 19px !important">
                          Assigned Visits :-
                          <span class="font-weight-500 red--text mr-2">{{
                            visits.visitBarcode
                          }}</span>
                        </div>
                        <br />
                      </template>
                      <span style="font-size: 18px !important">
                        Are you sure, You want to Approve this Leave
                      </span>

                      <v-chip outlined label color="green" class="ml-2"
                        ><span class="font-weight-600">{{
                          leaveBarcode
                        }}</span> </v-chip
                      >&nbsp;?
                    </span>
                  </div>
                  <div class="btx-div m-0" v-if="statusdata == 'cancelled'">
                    <span class="font-weight-600">
                      <template v-if="visits && visits.visitBarcode">
                        <div style="font-size: 19px !important">
                          Assigned Visits :-
                          <span class="font-weight-500 red--text mr-2">{{
                            visits.visitBarcode
                          }}</span>
                        </div>
                        <br />
                      </template>
                      <span style="font-size: 18px !important">
                        Are you sure, You want to Cancel this Leave</span
                      >

                      <v-chip outlined label color="teal" class="ml-2"
                        ><span class="font-weight-600">{{
                          leaveBarcode
                        }}</span> </v-chip
                      >&nbsp;?
                    </span>
                    <div class="mt-3" v-if="statusdata == 'cancelled'">
                      <label class="input-label required mb-1"
                        >Cancel Remark</label
                      >
                      <v-textarea
                        auto-grow
                        dense
                        :rules="[
                          validateRules.required(cancelled_remark, 'Remark'),
                        ]"
                        filled
                        color="cyan"
                        v-model="cancelled_remark"
                        placeholder="Reason for cancellation"
                        solo
                        flat
                        row-height="15"
                      ></v-textarea>
                    </div>
                  </div>
                  <div v-if="statusdata == 'rejected'">
                    <span class="font-weight-600">
                      <span style="font-size: 19px !important">
                        Are you sure, You want to Reject this Leave
                      </span>

                      <!--  {{ leaveId.length > 1 ? "these leaves" : "this Leave" }} -->
                      <v-chip outlined label color="red" class="ml-2">
                        <span class="font-weight-600">{{
                          leaveBarcode
                        }}</span> </v-chip
                      >&nbsp; ?
                    </span>

                    <div class="mt-3" v-if="statusdata == 'rejected'">
                      <label class="input-label required mb-1"
                        >Reject Remark</label
                      >
                      <v-textarea
                        auto-grow
                        dense
                        :rules="[
                          validateRules.required(rejected_remark, 'Remark'),
                        ]"
                        filled
                        color="cyan"
                        v-model="rejected_remark"
                        placeholder="Reason for rejected"
                        solo
                        flat
                        row-height="15"
                      ></v-textarea>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </template>
          <template v-slot:action>
            <v-btn
              class="mx-2 custom-grey-border custom-bold-button white--text"
              color="cyan"
              :disabled="!formValid"
              @click="dropData(visits.visitId)"
              style="min-width: 78px !important"
            >
              <template
                v-if="
                  visits &&
                  visits.visitId &&
                  visits.visitId.length > 0 &&
                  statusdata == 'approved'
                "
              >
                Approve & UnAssigned
              </template>
              <template v-else>
                <template v-if="statusdata == 'approved'"> Approve </template>
                <template v-if="statusdata == 'cancelled'"> Cancel </template>
                <template v-if="statusdata == 'rejected'"> Reject </template>
              </template>
            </v-btn>
            <v-btn
              class="mx-2 custom-grey-border custom-bold-button"
              @click="statusDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>
      </template>
    </ListingTemplate>
    <template v-if="create_leave_dialog">
      <CreateLeave
        :drawer="create_leave_dialog"
        :leaveUpdateData="leaveCreate"
        @close="
          leaveCreate = {};
          create_leave_dialog = false;
        "
        @refresh-data="getRows"
      ></CreateLeave>
    </template>
  </div>
</template>


<script>
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { PATCH } from "@/core/services/store/request.module";
// import { SET_FILTER } from "@/core/services/store/leave.module";
import { LeaveApplyEventBus } from "@/core/lib/leave.from.lib.js";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import {
  GET_LEAVE_STATUS,
  // SET_LOADING,
} from "@/core/services/store/leave.module";
// import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import CreateLeave from "@/view/pages/leave/Create-Or-Update/CreateLeave";
import JwtService from "@/core/services/jwt.service";
import DateRangePicker from "@/view/components/DateRangePicker";
import ValidationMixin from "@/core/plugins/validation-mixin";
export default {
  mixins: [CommonMixin, ValidationMixin, ListingMixin],
  name: "leave-list",
  data() {
    return {
      CurrentUser: JwtService.currentUser(),
      leaveCreate: null,
      create_leave_dialog: false,
      exportLoading: false,
      dates: [],
      statusDialog: false,
      pageModule: "leave-listing",
      routeAPI: "leave",
      routeName: "leave",
      routeDetailName: "leave.detail",
      status: "all",
      statusList: [],
      customThead: [],
      statusDropdown: [
        {
          text: "Approved",
          value: "approved",
          color: "green",
          headercolor: "primary",
          status: "2",
        },
        {
          text: "Rejected",
          value: "rejected",
          color: "red",
          headercolor: "primary",
          status: "3",
        },
        {
          text: "Cancelled",
          value: "cancelled",
          color: "teal",
          headercolor: "primary",
          status: "4",
        },
      ],

      leaveBarcode: null,
      leaveId: null,
      statusdata: "",
      rejected_remark: null,
      cancelled_remark: null,
      formValid: false,
      visits: {},
    };
  },
  components: {
    PageTips,
    draggable,
    PageHeaderCount,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
    DateRangePicker,
    CreateLeave,
  },
  watch: {
    dates: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param.length > 1) {
          this.listingSearch["dates"] = param;
        } else {
          this.listingSearch["dates"] = [];
        }
      },
    },
    "$route.query.status"(param) {
      this.status = param;
    },
  },
  methods: {
    dropData(visit) {
      this.autoRefresh = false;
      this.pageLoading = true;
      let payload = {
        visit: visit,
        leaves: this.leaveId,
        status: this.statusdata, // 1: Pending, 2: Approved, 3: Rejected 4: cancelled
        remark:
          this.statusdata == "rejected"
            ? this.rejected_remark
            : this.statusdata == "cancelled"
            ? this.cancelled_remark
            : null,
      };
      this.$store
        .dispatch(PATCH, {
          url: `leave/${this.leaveId}/${this.statusdata}`,
          data: payload,
        })
        .then(() => {
          this.statusDialog = false;
          this.detailDialog = false;
          // this.reject_remark = null;
          this.reject_remark = null;
          this.cancelled_remark = null;

          LeaveApplyEventBus.$emit("refresh");
          this.autoRefresh = true;
          // this.getAllLeaveStatus();
          this.getRows();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    // getAllLeaveStatus() {
    //   const _this = this;
    //   _this.$store.dispatch(SET_LOADING, true);
    //   _this.$store
    //     .dispatch(GET_LEAVE_STATUS, {})
    //     .catch((error) => {
    //       console.log({ error });
    //     })
    //     .finally(() => {
    //       _this.$store.dispatch(SET_LOADING, false);
    //     });
    // },
    getOverdue(data) {
      if (
        data.status == 1 &&
        moment(data.start_date).isBefore(moment(), "day")
      ) {
        return true;
      }
      return false;
    },
    updateStatus(status, data) {
      this.leaveBarcode = data.barcode;
      this.leaveId = data.id;
      this.statusdata = status;
      this.rejected_remark = null;
      this.cancelled_remark = null;

      this.statusDialog = true;

      this.$store.dispatch(GET_LEAVE_STATUS, {});
    },

    // updateStatus(status, data) {
    //   this.$emit("leave-details", { barcode: data.barcode, leaveId: data.id });
    //   this.$emit("status-data", status);
    //   this.$emit("status-dialog", true);
    //   this.$store.dispatch(GET_LEAVE_STATUS, {});
    // },
    getStatusColor(status) {
      if (status == 1) {
        return "orange darken-1";
      }
      if (status == 2) {
        return "green darken-1";
      }
      if (status == 3) {
        return "red darken-1";
      }
      return null;
    },

    isDisabled(leave) {
      return leave.status == 1 && this.CurrentUser.role == 1 ? false : true;
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Leave",
      },
    ]);
  },
  beforeMount() {
    const _this = this;
    this.isMountedRef = true;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.status = _this.$route.query.status || _this.status;

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 15;
  },
};
</script>
